import React from 'react';
import { ListItem, ListItemIcon, ListItemText, Switch, useTheme } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toggleTheme } from '../../features/Theme/themeActions';
import { ThemeMode } from '../../features/Theme/themeReducer';

interface ThemeToggleProps {
    themeMode: ThemeMode;
    toggleTheme: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ themeMode, toggleTheme }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isDark = themeMode === 'dark';

    const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        toggleTheme();
    };

    return (
        <ListItem
            sx={{
                display: 'flex',
                alignItems: 'center',
                '& .MuiListItemText-primary': { color: theme.palette.text.primary },
                '& .MuiListItemIcon-root': { color: theme.palette.text.primary, minWidth: 40 },
                '& .MuiListItemText-root': {
                    flex: '1 1 auto',
                    minWidth: 0,
                },
            }}
        >
            <ListItemIcon>
                {isDark ? <DarkMode /> : <LightMode />}
            </ListItemIcon>
            <ListItemText
                primary={isDark ? t('Dark Mode') : t('Light Mode')}
                sx={{
                    flex: '1 1 auto',
                    minWidth: 0,
                }}
            />
            <Switch
                checked={isDark}
                onChange={handleToggle}
                sx={{
                    flexShrink: 0,
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: theme.palette.primary.main,
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: theme.palette.primary.main,
                    },
                }}
            />
        </ListItem>
    );
};

const mapStateToProps = (state: any) => {
    const mode = state.theme?.mode || 'dark';
    return {
        themeMode: mode,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    toggleTheme: () => dispatch(toggleTheme()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemeToggle);

